'use client';

import { EPlatform } from '@/utils/enums/platform-enum';
import { useTranslations } from 'next-intl';
import ContactBanner from './components/ContactBanner';
import ContactFAQ from './components/ContactFAQ';
import ContactForm from './components/ContactForm';
import ContactList from './components/ContactList';
import { ContactPageData } from './page';

interface ContactZeeloolClientProps {
  initialData: ContactPageData;
  deviceType: EPlatform;
}

export default function ContactZeeloolClient({
  initialData,
  deviceType,
}: ContactZeeloolClientProps) {
  const t = useTranslations('contact-zeelool.page');
  const isMobile = deviceType !== EPlatform.WEB;

  return (
    <div className="contact-zeelool-page">
      {/* Banner部分 */}
      <ContactBanner isMobile={isMobile} />

      {isMobile ? (
        // 移动端布局 - 纵向排列
        <div>
          <div className="mt-32 bg-white px-14 pb-20">
            <ContactForm
              subjectOptions={initialData.subjectOptions}
              originSolutionOptions={initialData.originSolutionOptions}
              isMobile={isMobile}
            />
          </div>

          {/* 联系方式卡片部分 */}
          <ContactList isMobile={isMobile} />

          {/* FAQ搜索部分 */}
          <ContactFAQ defaultFaqList={initialData.defaultFaqList} isMobile={isMobile} />
        </div>
      ) : (
        // 桌面端布局 - 双栏布局
        <>
          {/* 主要内容区域 */}
          <div className="bg-white">
            <div className="relative max-w-[1440px] px-32 py-40 mx-auto">
              {/* 双栏内容区域 */}
              <div className="flex mt-0 relative gap-32">
                {/* 左栏：联系表单 (50% - 2.2vw) */}
                <div className="w-1/2">
                  <h2 className="text-2xl font-bb text-[#282828] leading-24 ">{t('emailUs')}</h2>

                  {/* 表单占位符 */}
                  <div className="mt-32 bg-white">
                    <ContactForm
                      subjectOptions={initialData.subjectOptions}
                      originSolutionOptions={initialData.originSolutionOptions}
                      isMobile={isMobile}
                    />
                  </div>
                </div>

                {/* 右栏：FAQ搜索 (50% - 2.2vw) */}
                <div className="w-1/2">
                  <ContactFAQ
                    defaultFaqList={initialData.defaultFaqList}
                    isMobile={isMobile}
                    className="absolute"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 联系方式卡片部分 */}
          <ContactList isMobile={isMobile} />
        </>
      )}
    </div>
  );
}
